<template>
    <dialogs-base :show.sync="dialog" max-width="20%">
        <template v-slot:body>
            
            <v-card>
                <v-card-title :class="['white--text', 'text--darken-3', 'redlighten-2', 'py-1', 'text-subtitle-1', 'font-weight-regular', colorTitle]">
                    <v-icon left color="white" small>{{ icon }}</v-icon> {{ title }}
                    <v-spacer></v-spacer>

                </v-card-title>
                <v-card-text class="pa-4">
                    {{ message }}
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn small color="grey lighten-2" @click="dialog = false" :disabled="loading">
                        Cancelar
                        <v-icon small right dark>mdi-close</v-icon>
                    </v-btn>
                    <v-btn small color="green" dark @click="emit('confirm')" :loading="loading" >
                        Confirmar
                        <v-icon small right dark>mdi-check</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>

        </template>
    </dialogs-base>
</template>

<script setup>

import { computed, defineProps, defineEmits } from 'vue'

const emit = defineEmits(['update:show', 'confirm'])

const props = defineProps({
    show: { type: Boolean, default: false },
    message: { type: String, default: "Você tem certeza que deseja continuar?" },
    loading: { type: Boolean, default: false },
    title: { type: String, default: "Confirmação" },
    icon: { type: String, default: "mdi-alert" },
    colorTitle: { type: String, default: "red lighten-2" }
})

const dialog = computed({
    get() {
        return props.show
    },
    set(value) {
        emit('update:show', value)
    }
})

</script>